import { isNull, isString } from 'utils/tsHelpers';
import { isEmptyString } from 'utils/stringHelpers';

export const isEmptyDate = (date: string | null) =>
  (isString(date) && isEmptyString(date)) || isNull(date);
